export const noticeAdminApi = {
    heading:[
        
        {
            head:"Notice Date"
        },
        {
            head:"Notice Type"
        },
        {
            head:"Notice For"
        },
        {
            head:"Title"
        },
        {
            head:"Checked By"
        },
        {
            head:"Active From"
        },
        {
            head:"Active To"
        },
        {
            head:"Published"
        },
        {
            head:"Action"
        }
    ],
    data:[
       {
        
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
    
      
     
   
       
    ]
}